export const formatName = (
  user:
    | { firstname?: string | null; lastname?: string | null }
    | null
    | undefined,
  fallback = 'Nom inconnu'
) => {
  if (!user?.firstname && !user?.lastname) {
    return fallback
  }
  return `${user.firstname || ''} ${user.lastname || ''}`.trim()
}
